import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSetRecoilState } from "recoil";

import { previousUrlState } from "store/store";

const useSavePreviousUrl = () => {
  const location = useLocation();
  const setPreviousUrl = useSetRecoilState(previousUrlState);
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    const currentPath = location.pathname;
    setPreviousUrl(currentUrl);
    setCurrentUrl(currentPath);
  }, [location]);
};

export default useSavePreviousUrl;
